// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"styles_closeIcon__1yQbx","closeButton":"styles_closeButton__Mzae7"};